import { render, staticRenderFns } from "./DialogueEditor.vue?vue&type=template&id=3acc1e4b&scoped=true&"
import script from "./DialogueEditor.vue?vue&type=script&lang=js&"
export * from "./DialogueEditor.vue?vue&type=script&lang=js&"
import style0 from "./DialogueEditor.vue?vue&type=style&index=0&id=3acc1e4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc1e4b",
  null
  
)

export default component.exports